<div class="flex items-center justify-center py-6" role="status">
  <hlm-spinner [size]="size" />

  @if (message) {
    <span class="ml-3 text-sm font-medium text-gray-600 dark:text-gray-400">{{ message }}</span>
  }
</div>
